import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import {
  Button,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Table,
} from "reactstrap";
import moment from "moment";
import PaginationBlock4 from "../../../../components/common/PaginationBlock4";
import { useSelector } from "react-redux";
import TimezoneClock from "../../../../components/common/TimeZone";

const Listing = ({
  _sortFn,
  sort,
  order,
  documentLogs,
  page,
  limit,
  _handleLimit,
  _handlePageChange,
  documentLogDetail,
  _setDocumentLogDetail,
  fileData,
  paginationStats,
}) => {
  console.log("documentLogs", documentLogs);
  const history = useHistory();
  const toggle = () => setModal(!modal);
  const modalToggleHandle = () => setModal(!modal);
  const [modal, setModal] = useState(false);
  // const [isAdminLoggedIn, setIsAdminLoggedIn] = useState(false)
  const isAdminLoggedIn = useSelector(
    (state) => state?.user?.user?.isAdminLoggedIn
  );
  const userDetail = useSelector((state) => state?.user?.user);
  // isAdminLoggedIn(isAdmin)

  const openModal = (item) => {
    _setDocumentLogDetail(item);
    console.log("version of modal", item);
    modalToggleHandle();
  };

  return (
    <>
      <Table responsive>
        <thead>
          <tr>
            <th
              className="sort-heading"
              onClick={() => {
                _sortFn({ sort: "userName", order: order === -1 ? 1 : -1 });
              }}
            >
              <div className="sort-elem-cell d-inline-flex align-items-center">
                UserName
                <span className="sort-cell d-inline-flex flex-column align-items-center">
                  {sort === "userName" ? (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="10"
                      height="14"
                      viewBox="0 0 10 14"
                    >
                      <g
                        id="Group_958"
                        data-name="Group 958"
                        transform="translate(-458 -170)"
                      >
                        {order != 1 ? (
                          <path
                            id="Polygon_5"
                            data-name="Polygon 5"
                            d="M5,0l5,6H0Z"
                            transform="translate(468 184) rotate(180)"
                          />
                        ) : (
                          <path
                            id="Polygon_6"
                            data-name="Polygon 6"
                            d="M5,0l5,6H0Z"
                            transform="translate(458 170)"
                          />
                        )}
                      </g>
                    </svg>
                  ) : (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="10"
                      height="14"
                      viewBox="0 0 10 14"
                    >
                      <g
                        id="Group_958"
                        data-name="Group 958"
                        transform="translate(-458 -170)"
                      >
                        <path
                          id="Polygon_5"
                          data-name="Polygon 5"
                          d="M5,0l5,6H0Z"
                          transform="translate(468 184) rotate(180)"
                        />

                        <path
                          id="Polygon_6"
                          data-name="Polygon 6"
                          d="M5,0l5,6H0Z"
                          transform="translate(458 170)"
                        />
                      </g>
                    </svg>
                  )}
                </span>
              </div>
            </th>
            <th
              className="sort-heading"
              onClick={() => {
                _sortFn({ sort: "logDetail", order: order === -1 ? 1 : -1 });
              }}
            >
              <div className="sort-elem-cell d-inline-flex align-items-center">
                Log
                <span className="sort-cell d-inline-flex flex-column align-items-center">
                  {sort === "logDetail" ? (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="10"
                      height="14"
                      viewBox="0 0 10 14"
                    >
                      <g
                        id="Group_958"
                        data-name="Group 958"
                        transform="translate(-458 -170)"
                      >
                        {order != 1 ? (
                          <path
                            id="Polygon_5"
                            data-name="Polygon 5"
                            d="M5,0l5,6H0Z"
                            transform="translate(468 184) rotate(180)"
                          />
                        ) : (
                          <path
                            id="Polygon_6"
                            data-name="Polygon 6"
                            d="M5,0l5,6H0Z"
                            transform="translate(458 170)"
                          />
                        )}
                      </g>
                    </svg>
                  ) : (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="10"
                      height="14"
                      viewBox="0 0 10 14"
                    >
                      <g
                        id="Group_958"
                        data-name="Group 958"
                        transform="translate(-458 -170)"
                      >
                        <path
                          id="Polygon_5"
                          data-name="Polygon 5"
                          d="M5,0l5,6H0Z"
                          transform="translate(468 184) rotate(180)"
                        />

                        <path
                          id="Polygon_6"
                          data-name="Polygon 6"
                          d="M5,0l5,6H0Z"
                          transform="translate(458 170)"
                        />
                      </g>
                    </svg>
                  )}
                </span>
              </div>
            </th>
            <th
              className="sort-heading"
              onClick={() => {
                _sortFn({
                  sort: "statusOfTransmission",
                  order: order === -1 ? 1 : -1,
                });
              }}
            >
              <div className="sort-elem-cell d-inline-flex align-items-center">
                Status
                <span className="sort-cell d-inline-flex flex-column align-items-center">
                  {sort === "statusOfTransmission" ? (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="10"
                      height="14"
                      viewBox="0 0 10 14"
                    >
                      <g
                        id="Group_958"
                        data-name="Group 958"
                        transform="translate(-458 -170)"
                      >
                        {order != 1 ? (
                          <path
                            id="Polygon_5"
                            data-name="Polygon 5"
                            d="M5,0l5,6H0Z"
                            transform="translate(468 184) rotate(180)"
                          />
                        ) : (
                          <path
                            id="Polygon_6"
                            data-name="Polygon 6"
                            d="M5,0l5,6H0Z"
                            transform="translate(458 170)"
                          />
                        )}
                      </g>
                    </svg>
                  ) : (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="10"
                      height="14"
                      viewBox="0 0 10 14"
                    >
                      <g
                        id="Group_958"
                        data-name="Group 958"
                        transform="translate(-458 -170)"
                      >
                        <path
                          id="Polygon_5"
                          data-name="Polygon 5"
                          d="M5,0l5,6H0Z"
                          transform="translate(468 184) rotate(180)"
                        />

                        <path
                          id="Polygon_6"
                          data-name="Polygon 6"
                          d="M5,0l5,6H0Z"
                          transform="translate(458 170)"
                        />
                      </g>
                    </svg>
                  )}
                </span>
              </div>
            </th>
            {/* <th className='sort-heading'>
                        File Name
                        <span className='sort-cell d-inline-flex flex-column align-items-center'>
                        <span className='d-inline-flex up'>
                        <img className='img-fluid' src={require('../../../../assets/img/icons/arrow-triangle-fill-up.svg')} />
                        </span>
                        <span className='d-inline-flex down'>
                        <img className='img-fluid' src={require('../../../../assets/img/icons/arrow-triangle-fill-down.svg')} />
                        </span>
                        </span>
                        </th> */}
            <th
              className="sort-heading"
              onClick={() => {
                _sortFn({ sort: "time", order: order === -1 ? 1 : -1 });
              }}
            >
              <div className="sort-elem-cell d-inline-flex align-items-center">
                Date Created
                <span className="sort-cell d-inline-flex flex-column align-items-center">
                  {sort === "time" ? (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="10"
                      height="14"
                      viewBox="0 0 10 14"
                    >
                      <g
                        id="Group_958"
                        data-name="Group 958"
                        transform="translate(-458 -170)"
                      >
                        {order != 1 ? (
                          <path
                            id="Polygon_5"
                            data-name="Polygon 5"
                            d="M5,0l5,6H0Z"
                            transform="translate(468 184) rotate(180)"
                          />
                        ) : (
                          <path
                            id="Polygon_6"
                            data-name="Polygon 6"
                            d="M5,0l5,6H0Z"
                            transform="translate(458 170)"
                          />
                        )}
                      </g>
                    </svg>
                  ) : (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="10"
                      height="14"
                      viewBox="0 0 10 14"
                    >
                      <g
                        id="Group_958"
                        data-name="Group 958"
                        transform="translate(-458 -170)"
                      >
                        <path
                          id="Polygon_5"
                          data-name="Polygon 5"
                          d="M5,0l5,6H0Z"
                          transform="translate(468 184) rotate(180)"
                        />

                        <path
                          id="Polygon_6"
                          data-name="Polygon 6"
                          d="M5,0l5,6H0Z"
                          transform="translate(458 170)"
                        />
                      </g>
                    </svg>
                  )}
                </span>
              </div>
            </th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {documentLogs?.result?.map((item, index) => {
            console.log("admin data in doc logs ->", item, index);
            return (
              <tr>
                {item?.userName ? <td>{item?.userName}</td> : item?.userNameDetail ?  <td>{item?.userNameDetail}</td>  : <td>-</td>}
                {/* <td>{fileData.name}</td> */}
                <td>{item?.logDetail}</td>
                <td>{item?.logDetail == "QC Verification" ? item?.QAVerified ? "Passed" : "Failed" : item?.statusOfTransmission}</td>
                <td>
                  {item?.time
                    ? moment(item?.time).format("MM/DD/YYYY") +
                      " " +
                      "at" +
                      " " +
                      moment(item?.time).format("h:mm a")
                    : ""}
                  {/* {moment(item?.updatedAt).format(
                                        "MMM DD,YYYY"
                                    ) + ' at ' + moment(item?.updatedAt).format(
                                        "h:mm a"
                                    )} */}
                </td>
                <td className="action-cell">
                  <Button color="link icon-btn" onClick={() => openModal(item)}>
                    <FontAwesomeIcon icon={faEye} />
                  </Button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
      <PaginationBlock4
        page={page}
        limit={limit}
        organizations={paginationStats}
        __handleLimit={_handleLimit}
        __handlePageChange={_handlePageChange}
      />
      {/* audit-log-detail Modal */}
      <Modal
        isOpen={modal}
        toggle={modalToggleHandle}
        className="audit-log-modal validate-modal"
      >
        <ModalHeader>
          Audit Log Detail
          <Button color="link" onClick={modalToggleHandle}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="34"
              height="34"
              viewBox="0 0 34 34"
            >
              <g data-name="Group 651" transform="translate(-1535 -134)">
                <g
                  fill="#fff"
                  stroke="#000"
                  strokeWidth="2"
                  data-name="Ellipse 30"
                  opacity="0.3"
                  transform="translate(1535 134)"
                >
                  <circle cx="17" cy="17" r="17" stroke="none"></circle>
                  <circle cx="17" cy="17" r="16" fill="none"></circle>
                </g>

                <path
                  d="M19.589 18l4.8-4.8a1.124 1.124 0 00-1.589-1.584l-4.8 4.8-4.8-4.8a1.124 1.124 0 10-1.584 1.584l4.8 4.8-4.8 4.8a1.124 1.124 0 001.584 1.584l4.8-4.8 4.8 4.8a1.124 1.124 0 101.584-1.584z"
                  data-name="Icon ionic-ios-close"
                  opacity="0.3"
                  transform="translate(1534.289 132.789)"
                ></path>
              </g>
            </svg>
          </Button>
        </ModalHeader>
        <ModalBody>
          <div className="audit-log-rw">
            <div className="list-info">
              <div className="row">
                <div className="col-md-4">
                  <label className="lbl">UserName</label>
                  <span className="desc d-block">
                    {documentLogDetail?.userName != "" ? (
                      <td>{documentLogDetail?.userName}</td>
                    ) : documentLogDetail?.userNameDetail != "" ?  (
                      <td>{documentLogDetail?.userNameDetail}</td>
                    ) :
                     (
                      <td>-</td>
                    )}
                  </span>
                </div>
                <div className="col-md-4">
                  <label className="lbl">Role</label>
                  <span className="desc d-block">
                    {documentLogDetail?.userRole ? (
                      <td>{documentLogDetail?.userRole?.roleName}</td>
                    ) : documentLogDetail?.admin ? (
                      <td>{documentLogDetail?.adminRole?.roleName}</td>
                    ) : (
                      <td>-</td>
                    )}
                  </span>
                </div>
                <div className="col-md-4">
                  <label className="lbl">Email</label>
                  <span className="desc d-block">
                    {documentLogDetail?.userData?.email ? (
                      <td>{documentLogDetail?.userData?.email}</td>
                    ) : documentLogDetail?.adminData?.email ? (
                      <td>{documentLogDetail?.adminData?.email}</td>
                    ) : (
                      <td>-</td>
                    )}
                  </span>
                </div>
                <div className="col-sm-12">
                  <label className="lbl">Date Modified</label>
                  <span className="desc d-block">
                    {documentLogDetail?.updatedAt && userDetail?.timezone ? (
                      <>
                        <TimezoneClock
                          timezone={userDetail.timezone}
                          dateTime={documentLogDetail?.updatedAt}
                          timeFormat={"MMM DD,YYYY"}
                        />{" "}
                        at{" "}
                        <TimezoneClock
                          timezone={userDetail.timezone}
                          dateTime={documentLogDetail?.updatedAt}
                          timeFormat={"h:mm a"}
                        />
                      </>
                    ) : (
                      moment(documentLogDetail?.updatedAt).format(
                        "MMM DD,YYYY"
                      ) +
                      " at " +
                      moment(documentLogDetail?.updatedAt).format("h:mm a")
                    )}

                    {/* {moment(documentLogDetail?.updatedAt).format(
                                            "MMM DD,YYYY"
                                        ) + ' at ' + moment(documentLogDetail?.updatedAt).format(
                                            "h:mm a"
                                        )} */}
                  </span>
                </div>
                <div className="col-sm-12">
                  <label className="lbl">Log Detailed</label>
                  <span className="desc d-block">
                    {documentLogDetail?.logDetail}
                  </span>
                </div>
                <div className='col-sm-12'>
                    <label className='lbl'>Process By
                    </label>
                    <span className='desc d-block'>
                        {documentLogDetail?.autoProcessed && documentLogDetail?.autoProcessed == true ? 'MORi Automation' : 
                        documentLogDetail?.userName != "" ? (
                          <td>{documentLogDetail?.userName}</td>
                        ) : (
                          <td>-</td>
                        )}
                    </span>
                </div>
                {documentLogDetail?.logDetail === "QC Verification" ? <div className="col-sm-12">
                  <label className="lbl">QC Verified</label>
                  <span className="desc d-block">
                    {documentLogDetail?.QAVerified ? "Passed" : "Failed"}
                  </span>
                </div> : null}
                {documentLogDetail?.ReasonForFailure ? <div className='col-sm-12'>
                  <label className='lbl'>Reason For Failure
                  </label>
                  <span className='desc d-block'>
                    {documentLogDetail?.ReasonForFailure}
                  </span>
                </div> : null}
                {documentLogDetail?.errorMessages?.length > 0 && (
                  <div className="col-sm-12">
                    <label className="lbl">Error Message</label>
                    {documentLogDetail.errorMessages.map((message, index) => (
                      <div
                        key={index}
                        className="col-sm-12 validation-error-list"
                      >
                        <Label className="">
                          <span className="txt">
                            <strong>{message}</strong>
                          </span>
                        </Label>
                      </div>
                    ))}
                  </div>
                )}




                {documentLogDetail?.otherReason && (
                  <div className="col-sm-12">
                    <label className="lbl">Other Reason</label>
                    <span className="desc d-block">
                      {documentLogDetail.otherReason}
                    </span>
                  </div>
                )}
                {documentLogDetail?.recipientsNames?.length ? (
                  <div className="audit-log-rw">
                    <div className="card updates-info">
                      <div className="card-header">Recipient Names</div>
                      <div className="card-body">
                        <ul className="list-unstyled d-flex flex-wrap">
                          {documentLogDetail?.recipientsNames?.map(
                            (item, index) => (
                              <li>
                                <span>
                                  {item?.email}{" "}
                                  {/* Access the value dynamically */}
                                </span>
                              </li>
                            )
                          )}
                        </ul>
                      </div>
                    </div>
                  </div>
                ) : null}

                {documentLogDetail?.reviewNotes?.length ? (
                  <div className='audit-log-rw'>
                    <div className='card updates-info'>
                      <div className='card-header'>Review Notes</div>
                      <div className='card-body'>
                        <div className="row">
                          {documentLogDetail?.reviewNotes?.map((item, index) => (
                            <div className="col-sm-12 validation-error-list">
                              <Label className="">
                                <span className="txt">
                                  {'• ' + item?.message}
                                </span>
                              </Label>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default Listing;
